/** @format */

import {Box, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import ButtonPlate from 'components/plates/ButtonPlate';

import {
  StyledRecommendations,
  StyledRecommendationsText,
  StyledRow,
  useSensorBarBunchStyles,
} from './styles';
import {VariantType} from '../model/types';

type Props = {
  description: string;
  totalFound: number;
  totalNew?: number;
  title: string;
  icon: string;
  onClick?: () => void;
  variant?: VariantType;
};

const SensorBarBunch = (props: Props) => {
  const {description, totalNew, totalFound, title, onClick, icon, variant = 'default'} = props;

  const classes = useSensorBarBunchStyles();
  const {t} = useTranslation();

  return (
    <StyledRow colorScheme={variant}>
      <ButtonPlate
        onClick={() => onClick && onClick()}
        rootClassName={classes.buttonPlate}
        containerClassName={classes.buttonPlateContainer}
        containerStyle={{backgroundColor: 'transparent'}}
      >
        <Box className={classes.content}>
          <Box className={classes.rowIcon}>
            <img alt='category icon' src={icon} width='24' height='24' />
          </Box>
          <Box className={classes.textContainer}>
            <Box className={classes.titleBox}>
              <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Typography className={classes.description}>{description}</Typography>
          </Box>
        </Box>

        <Box className={classes.recommendationsWrapper}>
          <StyledRecommendations colorScheme={variant}>
            <StyledRecommendationsText colorScheme={variant}>
              {totalFound === 0 && <Trans>Рекомендаций нет</Trans>}
              {totalFound > 0 && totalFound}
            </StyledRecommendationsText>
            {Boolean(totalNew && totalNew > 0) && (
              <StyledRecommendationsText colorScheme={variant}>
                &nbsp;({t('plurals.new_warnings', {count: totalNew})})
              </StyledRecommendationsText>
            )}
          </StyledRecommendations>
        </Box>
      </ButtonPlate>
    </StyledRow>
  );
};

export default SensorBarBunch;
